import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavMenuLeft = _resolveComponent("NavMenuLeft")!
  const _component_NavMenuRight = _resolveComponent("NavMenuRight")!
  const _component_Header = _resolveComponent("Header")!
  const _component_BuildSpecial = _resolveComponent("BuildSpecial")!
  const _component_LevelSpecial = _resolveComponent("LevelSpecial")!
  const _component_BuildPool = _resolveComponent("BuildPool")!
  const _component_LevelPool = _resolveComponent("LevelPool")!
  const _component_LoadMenu = _resolveComponent("LoadMenu")!
  const _component_SaveMenu = _resolveComponent("SaveMenu")!
  const _component_CraftMenu = _resolveComponent("CraftMenu")!
  const _component_InventoryMenu = _resolveComponent("InventoryMenu")!
  const _component_CharStats = _resolveComponent("CharStats")!
  const _component_BuildSkills = _resolveComponent("BuildSkills")!
  const _component_LevelSkills = _resolveComponent("LevelSkills")!
  const _component_Traits = _resolveComponent("Traits")!
  const _component_Actions = _resolveComponent("Actions")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Perks = _resolveComponent("Perks")!
  const _component_EmptyPerks = _resolveComponent("EmptyPerks")!
  const _component_SupportPerks = _resolveComponent("SupportPerks")!
  const _component_InfoPanel = _resolveComponent("InfoPanel")!
  const _component_ControlPanel = _resolveComponent("ControlPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "main-container",
      class: _normalizeClass(["noselect main-grid", `${_ctx.state.build.info.phase}-phase-grid-areas`])
    }, [
      _createVNode(_component_NavMenuLeft),
      _createVNode(_component_NavMenuRight),
      _createVNode(_component_Header),
      _createVNode(_Transition, {
        name: "special-transition",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.state.build.info.phase === 'create')
            ? (_openBlock(), _createBlock(_component_BuildSpecial, { key: 0 }))
            : (_openBlock(), _createBlock(_component_LevelSpecial, { key: 1 }))
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "pool-transition",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.state.build.info.phase === 'create')
            ? (_openBlock(), _createBlock(_component_BuildPool, { key: 0 }))
            : (_openBlock(), _createBlock(_component_LevelPool, { key: 1 }))
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "traits-transition",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.state.ui.activeCharStatsView === 'loadMenu')
            ? (_openBlock(), _createBlock(_component_LoadMenu, { key: 0 }))
            : (_ctx.state.ui.activeCharStatsView === 'saveMenu')
              ? (_openBlock(), _createBlock(_component_SaveMenu, { key: 1 }))
              : (_ctx.state.ui.activeCharStatsView === 'craftMenu')
                ? (_openBlock(), _createBlock(_component_CraftMenu, { key: 2 }))
                : (_ctx.state.ui.activeCharStatsView === 'inventoryMenu')
                  ? (_openBlock(), _createBlock(_component_InventoryMenu, { key: 3 }))
                  : (_openBlock(), _createBlock(_component_CharStats, { key: 4 }))
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "skills-transition",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.state.build.info.phase === 'create')
            ? (_openBlock(), _createBlock(_component_BuildSkills, { key: 0 }))
            : (_openBlock(), _createBlock(_component_LevelSkills, { key: 1 }))
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "traits-transition",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.state.build.info.phase === 'create')
            ? (_openBlock(), _createBlock(_component_Traits, { key: 0 }))
            : (_openBlock(), _createBlock(_component_Actions, { key: 1 }))
        ]),
        _: 1
      }),
      _createVNode(_component_Footer),
      (_ctx.state.build.info.phase === 'level')
        ? (_openBlock(), _createBlock(_component_Perks, { key: 0 }))
        : (_openBlock(), _createBlock(_component_EmptyPerks, { key: 1 })),
      _createVNode(_Transition, {
        name: "support-perks-transition",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.state.build.info.phase === 'level')
            ? (_openBlock(), _createBlock(_component_SupportPerks, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_InfoPanel),
      _createVNode(_component_ControlPanel)
    ], 2)
  ]))
}